import React, { Component } from 'react';

// Externals
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Material helpers
import { withStyles } from '@material-ui/core/styles';

// Material components
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';

// Component styles
const styles = theme => ({
  root: {
    padding: theme.spacing(4),
    backgroundColor: 'inherit',
  },
  company: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(0.5)
  },
  listItemText: {
    fontWeight: 500,
    //color: theme.palette.text.secondary
    color:'#525252'
},
});


class Footer extends Component {
  
  
  render() {
    const { classes, className } = this.props;

    const rootClassName = classNames(classes.root, className);

    return (
      <div className={rootClassName}>
        <Divider />
        <Typography
          className={classes.company}
          variant="body1"
        >
        </Typography>
        <Typography variant="caption" className={classes.listItemText}>
          {process.env.REACT_APP_VERSION}
        </Typography>
      </div>
    );
  }
}

Footer.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Footer);
